module.exports = __webpack_public_path__ + "static/media/dejeugd.1bfd6592.jpg";